import { render, staticRenderFns } from "./AuthSecondPopupIframe.vue?vue&type=template&id=f5e7c1fa&"
import script from "./AuthSecondPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./AuthSecondPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports